<template>
  <div>
    <div class="container">
      <titular />
      <ul class="list-inline">
        <li class="list-inline-item">
          <Gis scope="https://www.googleapis.com/auth/calendar.readonly" :parentAccessToken="accessToken" @cambiarAutorizacion="value => accessToken = value" />
        </li>
        <li class="list-inline-item" v-show="accessToken">
          <button class="btn btn-secondary" @click="getData" :disabled="loading.actualizarDatos"><i-submit icono="fa-rotate" :loading="loading.actualizarDatos" />Actualitzar recursos</button>
        </li>
      </ul>
    </div>
    <template v-if="accessToken">
      <template v-if="existen_datos">
        <div class="container-xl">
          <div class="row mb-5">
            <div class="col">
              <form class="form-inline" @submit.prevent="listarEventos">
                <div class="input-group mb-2 mr-sm-2">
                  <div class="input-group-prepend">
                    <div class="input-group-text"><i class="fas fa-user" title="Treballador" v-tooltip></i></div>
                  </div>
                  <select class="custom-select" required v-model="trabajador_escogido" @change="submitForm">
                    <option value="">Treballador</option>
                    <option v-for="(trabajador, index) in trabajadores" :key="index" :value="trabajador.id">{{ trabajador.nombre }}</option>
                  </select>
                </div>
                <div class="input-group mb-2 mr-sm-2">
                  <div class="input-group-prepend">
                    <div class="input-group-text">Inici</div>
                  </div>
                  <input type="date" class="form-control" v-model="rango_inicio" :min="rango_min" :max="rango_fin" required />
                </div>
                <div class="input-group mb-2 mr-sm-2">
                  <div class="input-group-prepend">
                    <div class="input-group-text">Fi</div>
                  </div>
                  <input type="date" class="form-control" v-model="rango_fin" :min="rango_inicio" :max="rango_max" required />
                </div>
                <button type="submit" ref="submitForm" class="btn btn-primary mb-2 mr-1" :disabled="es_buscando"><i class="fas mr-1" :class="es_buscando ? 'fa-spinner fa-spin' : 'fa-search'"></i>Cercar</button>
                <button type="reset" class="btn btn-secondary mb-2 ml-auto" @click="reiniciarFilas"><i class="fas fa-backspace mr-1"></i>Reiniciar</button>
              </form>
            </div>
          </div>
        </div>
        <template v-if="filasProcesadas.length">
          <div class="container-fluid">
            <div class="row mb-5">
              <div class="col">
                <h2 class="text-center">
                  <span v-if="nombre_trabajador_escogido != ''">PD entrades per <b>{{ nombre_trabajador_escogido }}</b></span>
                  <span v-show="total_horas > 0" class="badge badge-pill badge-secondary ml-3" title="Comput total d'hores de totes les files" v-tooltip>{{ total_horas }}h</span>
                </h2>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col">
                <div class="dropdown">
                  <a class="btn dropdown-toggle" href="#" role="button" id="dropdown-pd" data-toggle="dropdown" aria-expanded="false" :class="[{ disabled: !total_validas }, filasProcesadas.length == total_validas ? 'btn-primary' : 'btn-secondary']" :tabindex="total_validas ? '' : '-1'" :aria-disabled="total_validas ? 'false' : 'true'">
                    <template v-if="filasProcesadas.length == total_validas">Gestionar totes<span class="badge badge-pill badge-secondary ml-3">{{ filasProcesadas.length }}</span>
                    </template>
                    <template v-else>Gestionar vàlides<span class="badge badge-pill badge-danger ml-3">
                        <b>{{ total_validas }}</b>/{{ filasProcesadas.length }}</span>
                    </template>
                  </a>

                  <div class="dropdown-menu" aria-labelledby="dropdown-pd">
                    <button class="dropdown-item" @click="exportarFilas"><i class="fa-solid fa-download fa-fw mr-1"></i>Exportar en arxiu</button>
                    <button class="dropdown-item" @click="crearMultiple" :class="{ disabled: loading.creacionMultiple }"><i class="fas fa-plus fa-fw mr-1"></i>Afegir com dedicacions</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-5">
              <div class="col">
                <div class="table-responsive">
                  <table class="table table-striped table-hover">
                    <thead class="thead-light">
                      <tr>
                        <th scope="col">Data</th>
                        <th scope="col">Literal</th>
                        <th scope="col">Franja</th>
                        <th scope="col">Hores</th>
                        <th scope="col">Client</th>
                        <th scope="col">Projecte</th>
                        <th scope="col">Accions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(fila, index) in filasProcesadas" :key="index">
                        <td>
                          <template v-if="fila.esFechaCalendar">
                            <div class="d-flex align-items-center form-control-plaintext form-control-sm">
                              <i v-if="fila.literalCompleto" class="fas fa-quote-right mr-1" role="button" :title="'PD original del ' + fila.fecha" ref="popovers" v-popover :data-content="`<pre>${fila.literalCompleto}</pre>`" data-html="true" data-placement="auto"></i>
                              {{ fila.fecha }}
                            </div>
                          </template>
                          <template v-else>
                            <input class="form-control form-control-sm" type="date" v-model="fila.fecha" />
                          </template>
                        </td>
                        <td class="font-italic resaltado">
                          <div v-if="fila.esFechaCalendar" v-html="resaltarFila(fila)" class="form-control-plaintext form-control-sm d-inline-block"></div>
                        </td>
                        <td>
                          <div class="d-inline-flex">
                            <input class="form-control form-control-sm" type="time" v-model="fila.franjaInicial" step="900" @blur="$event.target.reportValidity()" :max="fila.franjaFinal" :tabindex="fila.esFechaCalendar ? '-1' : ''" />
                            <b class="mx-1 form-control-plaintext form-control-sm">-</b>
                            <input class="form-control form-control-sm" type="time" v-model="fila.franjaFinal" step="900" @blur="$event.target.reportValidity()" :min="fila.franjaInicial" :tabindex="fila.esFechaCalendar ? '-1' : ''" />
                          </div>
                        </td>
                        <td>
                          <span v-show="!isNaN(fila.franja)" class="form-control-plaintext form-control-sm" :class="{ 'text-danger': !fila.franjaValida }">
                            <span v-if="fila.franjaSolapada" title="Hores solapades" style="cursor: help;" v-tooltip>{{ fila.franja }}</span>
                            <span v-else>{{ fila.franja }}</span>
                          </span>
                        </td>
                        <td class="sub-input-min-width">
                          <vue-typeahead-bootstrap ref="clientes" :inputClass="typeof filasProcesadas[index].cliente !== 'object' ? 'text-danger form-control-sm' : 'form-control-sm'" v-model="filas_cliente[index]" :data="clientes" :serializer="(s) => s.nombre" @hit="seleccionarCliente" @input="seleccionarFila(index, 'cliente')" :placeholder="filasProcesadas[index].cliente_placeholder" :showAllResults="!filas_cliente[index].length" :showOnFocus="true" :maxMatches="clientes.length" />
                        </td>
                        <td class="sub-input-min-width">
                          <vue-typeahead-bootstrap ref="proyectos" :inputClass="typeof filasProcesadas[index].proyecto !== 'object' ? 'text-danger form-control-sm' : 'form-control-sm'" v-model="filas_proyecto[index]" :data="typeof filasProcesadas[index].cliente === 'object' ? (typeof proyectos_clientes[filasProcesadas[index].cliente.id] !== 'undefined' ? proyectos_clientes[filasProcesadas[index].cliente.id] : []) : proyectos" :serializer="(s) => s.nombre" @hit="seleccionarProyecto" @input="seleccionarFila(index, 'proyecto')" :placeholder="filasProcesadas[index].proyecto_placeholder" :showAllResults="!filas_proyecto[index].length && typeof filasProcesadas[index].cliente === 'object'" :showOnFocus="!filas_proyecto[index].length && typeof filasProcesadas[index].cliente === 'object'" :maxMatches="proyectos.length" />
                        </td>
                        <td class="text-nowrap">
                          <div class="btn-group" role="group" aria-label="Accions">
                            <button type="button" class="btn btn-secondary btn-sm" @click="retirarFila(index)" tabindex="-1">
                              <i class="fas fa-trash-alt fa-fw"></i>
                              <span class="ml-1 d-none d-lg-inline">Retirar</span>
                            </button>
                            <button type="button" class="btn btn-secondary btn-sm" @click="insertarFila(index)" tabindex="-1">
                              <i class="fas fa-level-down-alt fa-fw"></i>
                              <span class="ml-1 d-none d-lg-inline">Inserir</span>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <vacio>Utilitza el formulari superior per trobar les programacions diàries.</vacio>
        </template>
      </template>
      <template v-else>
        <div class="container">
          <div class="row">
            <div class="col text-center text-muted">
              <i class="fas fa-10x mb-5 fa-database"></i>
              <div class="alert alert-warning" role="alert"><i class="fas fa-exclamation-triangle mr-1"></i>Les dades encara no s'han carregat.</div>
            </div>
          </div>
        </div>
      </template>
    </template>
    <template v-else>
      <div class="container">
        <div class="row">
          <div class="col text-center text-muted">
            <i class="fas fa-10x mb-5 fa-unlock"></i>
            <div class="alert alert-warning" role="alert"><i class="fas fa-exclamation-triangle mr-1"></i>Si us plau, autoritza l'accés d'aquesta app a un compte Google que pugui veure els calendaris.</div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<style lang="scss">
#docpicker {
  top: 0;
  left: 0;
  opacity: 0;
  font-size: 0;
}

.popover-close {
  top: 0;
  right: 0;
}

.sub-input-min-width input {
  min-width: 200px !important;
}

.resaltado {
  max-width: 500px;
}
</style>

<script>
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import htmlToFormattedText from "html-to-formatted-text";
import Gis from "../components/GIS.vue";

export default {
  components: {
    "vue-typeahead-bootstrap": VueTypeaheadBootstrap,
    Gis,
  },
  name: "PD",
  inject: ["calcularFranja", "comprobarFranjaValida"],
  data() {
    return {
      accessToken: null,
      trabajador_escogido: "",
      rango_inicio: "",
      rango_fin: "",
      dias_superior: -30,
      dias_inferior: 365,
      filas: [],
      filas_cliente: [],
      filas_proyecto: [],
      fila_actual: null,
      trabajadores: [],
      clientes: [],
      proyectos: [],
      proyectos_clientes: [],
      access_columnas: ["DATA", "ID TREBALLADOR", "ID CLIENT", "ID PROJECTE", "HORES"],
      link_descarga: "",
      es_buscando: false,
      tostada: null,
      loading: {
        creacionMultiple: false,
        actualizarDatos: false,
      },
      hayCambiosUnload: false,
    };
  },
  computed: {
    filasProcesadas() {
      let horaMaxima = null;
      let fecha = null;

      return this.filas.map(fila => {
        if (!fila.franjaInicial) return fila;
        if (!fila.franjaFinal) return fila;

        if (fecha != fila.fecha) {
          horaMaxima = null;
        }

        let partesInicio = fila.franjaInicial.split(":");
        let partesFinal = fila.franjaFinal.split(":");

        let horaInicio = new Date();
        let horaFinal = new Date();

        horaInicio.setHours(partesInicio[0], partesInicio[1]);
        horaFinal.setHours(partesFinal[0], partesFinal[1]);

        fila.franja = parseFloat(((horaFinal - horaInicio) / (3600 * 1000)).toFixed(2));
        fila.franjaSolapada = horaMaxima && horaMaxima > fila.franjaInicial;
        fila.franjaValida = !horaMaxima || horaMaxima <= fila.franjaInicial ? this.comprobarFranjaValida(fila.franja) : false;

        horaMaxima = fila.franjaFinal;
        fecha = fila.fecha;

        return fila;
      });
    },
    existen_datos() {
      return this.trabajadores.length > 0 && this.clientes.length > 0 && this.proyectos.length > 0;
    },
    nombre_trabajador_escogido() {
      var trabajador = this.getTrabajadorById(this.trabajador_escogido);
      return trabajador !== null ? trabajador.nombre : "";
    },
    rango_max() {
      let date = new Date();

      date.setDate(date.getDate() - this.dias_superior);

      return this.toDateISOString(date);
    },
    rango_min() {
      let date = new Date();

      date.setDate(date.getDate() - this.dias_inferior);

      return this.toDateISOString(date);
    },
    total_horas() {
      let total = 0;

      this.filasProcesadas.map(function (fila) {
        if (fila.franjaValida) {
          total += fila.franja;
        }
      });

      return parseFloat(total).toFixed(2);
    },
    total_validas() {
      let total = 0;

      this.filasProcesadas.map(function (fila) {
        if (typeof fila.cliente === "object" && typeof fila.proyecto === "object" && fila.franjaValida) {
          total++;
        }
      });

      return total;
    },
  },
  created() {
    this.accessToken = localStorage.getItem("calendarToken");
    this.rango_fin = new Date().toISOString().split("T")[0];

    this.getData();
  },
  mounted() {
    $(document).on("click", ".popover-close", function () {
      $(this).parents(".popover").popover("hide");
    });

    $(document).on("show.bs.popover", '[data-toggle="popover"]', function (e) {
      $('[data-toggle="popover"]').not(this).popover("hide");
    });
  },
  beforeRouteLeave(to, from, next) {
    next(!this.hayCambiosUnload || (this.hayCambiosUnload && confirm("En aquest panell hi ha canvis sense desar i es podrien perdre. Vols canviar de panell sense desar aquestes dades?")));
  },
  destroyed() {
    this.$toast.clear();
  },
  methods: {
    getData() {
      this.loading.actualizarDatos = true;

      this.$http.get("api/clients?activos&order=titol").then((response) => {
        this.clientes = response.data.map((a) => {
          return { id: a.id, nombre: a.titol };
        });

        this.loading.actualizarDatos = false;
      });

      this.$http.get("api/treballadors?google_calendar&order=nom").then((response) => {
        this.trabajadores = response.data.map((a) => {
          return { id: a.id, nombre: a.nom, email: a.email_calendar };
        });

        this.loading.actualizarDatos = false;
      });

      this.$http.get("api/projectes?activos").then((response) => {
        this.proyectos = response.data.map((a) => {
          return { id: a.id, nombre: a.titol, id_cliente: a.id_client };
        });

        this.proyectos.forEach(proyecto => {
          this.rellenarProyectosClientes(proyecto.id_cliente, proyecto.id, proyecto.nombre);
        });

        this.loading.actualizarDatos = false;
      });
    },
    retirarFila(fila) {
      this.filas.splice(fila, 1);
      this.filas_cliente.splice(fila, 1);
      this.filas_proyecto.splice(fila, 1);

      if (this.$refs.tooltips) {
        this.$refs.tooltips.forEach((element) => {
          // Arregla el doble tooltip generado al actualizar los elementos
          $(element).tooltip("dispose");
        });
      }

      if (this.$refs.popovers) {
        this.$refs.popovers.forEach((element) => {
          // Actualiza los popovers generados
          $(element).popover("dispose");
        });
      }
    },
    insertarFila(fila) {
      this.filas_cliente.splice(fila + 1, 0, "");
      this.filas_proyecto.splice(fila + 1, 0, "");

      this.filas.splice(fila + 1, 0, {
        fecha: null,
        cliente: "",
        cliente_placeholder: "",
        proyecto: "",
        proyecto_placeholder: "",
        franja: 0,
        hora1Literal: "",
        hora2Literal: "",
        franjaInicial: null,
        franjaFinal: null,
        franjaValida: false,
      });

      if (this.$refs.tooltips) {
        this.$refs.tooltips.forEach((element) => {
          // Arregla el doble tooltip generado al actualizar los elementos
          $(element).tooltip("dispose");
        });
      }

      if (this.$refs.popovers) {
        this.$refs.popovers.forEach((element) => {
          // Actualiza los popovers generados
          $(element).popover("dispose");
        });
      }
    },
    exportarFilas(event) {
      let separador = ";";
      let exportacion_filas = [this.access_columnas.join(separador)];

      this.filasProcesadas.forEach(element => {
        let franja = '"' + element.franja.toString().replaceAll(".", ",") + '"';

        if (typeof element.cliente === "object" && typeof element.proyecto === "object" && element.franjaValida) {
          exportacion_filas.push([element.esFechaCalendar ? element.fecha : new Date(element.fecha).toLocaleDateString(navigator.language, { year: "numeric", month: "2-digit", day: "2-digit" }), this.trabajador_escogido, element.cliente.id, element.proyecto.id, franja].join(separador));
        }
      });

      const link = document.createElement("a");
      link.href = URL.createObjectURL(new Blob(["\ufeff", exportacion_filas.join("\n")], { type: "text/csv;charset=utf-8;" }));
      link.download = "ecostudi_pd.csv";
      link.click();

      this.hayCambiosUnload = false;
    },
    crearMultiple() {
      this.loading.creacionMultiple = true;

      this.$http
        .post("api/dedicacions", {
          filas: this.filasProcesadas
            .filter((element) => typeof element.cliente === "object" && typeof element.proyecto === "object" && element.franjaValida)
            .map((element) => {
              let partesFecha = element.fecha.split("/");
              let partesHora = element.franjaInicial.split(":");

              return { data_dedicacio: element.esFechaCalendar ? new Date(Date.UTC(partesFecha[2], partesFecha[1] - 1, partesFecha[0], partesHora[0], partesHora[1])).toISOString().replace("T", " ") : `${element.fecha} ${element.franjaInicial}`, id_treballador: this.trabajador_escogido, id_client: element.cliente.id, id_projecte: element.proyecto.id, temps: element.franja };
            }),
        })
        .then((response) => {
          this.loading.creacionMultiple = false;

          this.$nextTick(function () {
            if (response.status == 201) {
              this.$toast.clear();
              this.$toast.open({ position: "top", message: `${response.data.total} dedicacions creades correctament.` });

              this.hayCambiosUnload = false;
            } else {
              this.$toast.open({ type: "warning", position: "top", message: `No s'ha creat cap dedicació.` });
            }
          });
        })
        .catch((error) => {
          this.loading.creacionMultiple = false;
        });
    },
    /**
     * Print the summary and start datetime/date of the next ten events in
     * the authorized user's calendar. If no events are found an
     * appropriate message is printed.
     */
    listarEventos() {
      this.es_buscando = true;

      this.reiniciarFilas();

      fetch(`https://www.googleapis.com/calendar/v3/calendars/${this.getTrabajadorById(this.trabajador_escogido).email}/events?${new URLSearchParams({
        timeMin: new Date(this.rango_inicio).toISOString(),
        timeMax: new Date(this.rango_fin + " 23:59:59").toISOString(),
        showDeleted: false,
        singleEvents: true,
        orderBy: "startTime",
      })}`, {
        headers: {
          'Authorization': `Bearer ${this.accessToken}`,
        },
      })
        .then(response => {
          switch (response.status) {
            case 401:
              this.accessToken = null
              break;
            case 404:
              this.$toast.open({ type: "error", position: "top", message: "No hi ha permís per veure aquest calendari." });
              break;
          }

          return response;
        })
        .then(response => response.json())
        .then(response => {
          var i;
          var events = response.items;
          let opciones = [];

          if (events.length > 0) {
            for (i = 0; i < events.length; i++) {
              var event = events[i];

              if (event.summary && event.summary.substring(0, 2).toLowerCase() == "pd") {
                var tareas = htmlToFormattedText(event.description)
                  .replaceAll(/\u00a0/g, " ")
                  .split("\n");
                var when = event.start.dateTime;

                if (!when) {
                  when = event.start.date;
                }

                tareas.forEach(element => {
                  if (element.length) {
                    let horas = element.split(/(^\s?((([0-1]{0,1}[0-9])|(2[0-3]))(([:\.]{1})[0-5]{0,1}[0-9]){1})(\s?[\-–]\s?)((([0-1]{0,1}[0-9])|(2[0-3]))(([:\.]{1})[0-5]{0,1}[0-9]){1})(\s?h\s?)?)/);

                    if (horas.length > 1) {
                      let texto_sin_horas = element.replace(horas[1], "");
                      let primera_hora = horas[2];
                      let segunda_hora = horas[horas.findIndex((str) => /^\s?[\-–]\s?$/.test(str)) + 1];
                      let franja_calculada = this.calcularFranja(primera_hora, segunda_hora);

                      let textos = texto_sin_horas.split(/\s?\/\s?/);
                      let nombre_cliente = textos[0] ? textos[0].trim() : "";
                      let nombre_proyecto = textos[1] ? textos[1].trim() : "";

                      let cliente = this.getClienteByNombre(nombre_cliente);
                      let proyecto = cliente ? this.getProyectoByNombre(nombre_proyecto, cliente.id) : this.getProyectoByNombreUnico(nombre_proyecto);

                      this.filas.push({
                        fecha: new Date(when).toLocaleDateString(navigator.language, { year: "numeric", month: "2-digit", day: "2-digit" }),
                        esFechaCalendar: true,
                        cliente: cliente === null ? nombre_cliente : cliente,
                        cliente_placeholder: nombre_cliente,
                        proyecto: proyecto === null ? nombre_proyecto : proyecto,
                        proyecto_placeholder: nombre_proyecto,
                        franja: franja_calculada !== null ? franja_calculada.diferencia : 0,
                        literalCompleto: event.description,
                        hora1Literal: primera_hora,
                        hora2Literal: segunda_hora,
                        franjaInicial: franja_calculada !== null ? franja_calculada.horaInicio : null,
                        franjaFinal: franja_calculada !== null ? franja_calculada.horaFinal : null,
                        texto: element,
                      });

                      this.filas_cliente.push(cliente === null ? nombre_cliente : cliente.nombre);
                      this.filas_proyecto.push(proyecto === null ? nombre_proyecto : proyecto.nombre);
                    }
                  }
                });
              }
            }

            // Autoasociar cliente en caso de que por el texto inicial solamente haya uno en el desplegable
            this.$nextTick(() => {
              this.$refs.clientes.forEach((element, index) => {
                opciones = element.$refs.list.actionableItems;

                if (opciones.length == 1) {
                  this.seleccionarFila(index, "cliente");

                  if (typeof this.filasProcesadas[this.fila_actual].cliente !== "object") {
                    this.filas_cliente[this.fila_actual] = opciones[0].data.nombre;

                    this.seleccionarCliente(this.getClienteById(opciones[0].data.id));
                  }
                }
              });

              // Autoasociar proyecto en caso de que por el texto inicial solamente haya uno en el desplegable y sea del mismo cliente o no haya cliente seleccionado
              this.$refs.proyectos.forEach((element, index) => {
                opciones = element.$refs.list.actionableItems;

                if (opciones.length == 1 && (typeof this.filasProcesadas[this.fila_actual].cliente !== "object" || (typeof this.filasProcesadas[this.fila_actual].cliente === "object" && this.filasProcesadas[this.fila_actual].cliente.id == opciones[0].data.id_cliente))) {
                  this.seleccionarFila(index, "proyecto");

                  if (typeof this.filasProcesadas[this.fila_actual].proyecto !== "object") {
                    this.filas_proyecto[this.fila_actual] = opciones[0].data.nombre;

                    this.seleccionarProyecto(this.getProyectoById(opciones[0].data.id));
                  }
                }
              });
            });
          }
        })
        .catch(error => console.error(error))
        .finally(() => this.es_buscando = false);
    },
    toDateISOString(date) {
      return date.toISOString().split("T")[0];
    },
    getTrabajadorById(id) {
      var trabajador = this.trabajadores.find((element) => element.id == id);
      return trabajador ? trabajador : null;
    },
    getClienteById(id) {
      var elemento = this.clientes.find((element) => element.id == id);
      return elemento ? elemento : null;
    },
    getProyectoById(id) {
      var elemento = this.proyectos.find((element) => element.id == id);
      return elemento ? elemento : null;
    },
    getClienteByNombre(nombre) {
      var elemento = this.clientes.find((element) => element.nombre.toLowerCase() == nombre.toLowerCase());
      return elemento ? elemento : null;
    },
    getProyectoByNombre(nombre, id_cliente) {
      var elemento = this.proyectos.find((element) => element.id_cliente == id_cliente && element.nombre.toLowerCase() == nombre.toLowerCase());
      return elemento ? elemento : null;
    },
    getProyectoByNombreUnico(nombre) {
      var elementos = this.proyectos.filter((element) => element.nombre.toLowerCase() == nombre.toLowerCase());

      return elementos.length == 1 ? elementos[0] : null;
    },
    submitForm() {
      this.$refs.submitForm.click();
    },
    seleccionarCliente(elemento) {
      this.seleccionarClienteSimple(elemento);

      // Autoasociar proyecto en caso de que solamente haya uno en el array
      if (typeof this.proyectos_clientes[elemento.id] !== "undefined" && this.proyectos_clientes[elemento.id].length == 1) {
        let proyecto = this.proyectos_clientes[elemento.id][0];
        this.filas_proyecto[this.fila_actual] = proyecto.nombre;

        this.seleccionarProyecto(proyecto);
      } else if (typeof this.filasProcesadas[this.fila_actual].proyecto === "object" && this.filasProcesadas[this.fila_actual].proyecto.id_cliente != elemento.id) {
        // Desasociar proyecto que hubiera si no pertenece a este mismo cliente seleccionado
        this.seleccionarProyecto(this.filasProcesadas[this.fila_actual].proyecto.nombre);
      }
    },
    seleccionarClienteSimple(elemento) {
      this.filasProcesadas[this.fila_actual].cliente = elemento;

      if (typeof this.proyectos_clientes[this.filasProcesadas[this.fila_actual].cliente.id] === "undefined") {
        let misiva = `${this.filas_cliente[this.fila_actual]} no té cap projecte.`;

        if (!this.tostada || (this.tostada && this.tostada.message != misiva)) {
          this.tostada = this.$toast.open({
            type: "warning",
            position: "top",
            message: misiva,
            duration: 5000,
            onDismiss: () => {
              this.tostada = null;
            },
          });
        }
      }
    },
    seleccionarProyecto(elemento) {
      this.filasProcesadas[this.fila_actual].proyecto = elemento;

      if (typeof elemento === "object" && typeof this.filasProcesadas[this.fila_actual].cliente !== "object") {
        this.seleccionarClienteSimple(this.getClienteById(this.filasProcesadas[this.fila_actual].proyecto.id_cliente));

        this.filas_cliente[this.fila_actual] = this.filasProcesadas[this.fila_actual].cliente.nombre;
      }
    },
    seleccionarFila(index, modelo) {
      this.fila_actual = index;

      this.filas[this.fila_actual][modelo] = this["filas_" + modelo][this.fila_actual];
    },
    reiniciarFilas() {
      this.filas = [];
      this.filas_cliente = [];
      this.filas_proyecto = [];
      this.fila_actual = null;
    },
    rellenarProyectosClientes(id_cliente, id_proyecto, nombre_proyecto) {
      if (typeof this.proyectos_clientes[id_cliente] == "undefined") {
        this.proyectos_clientes[id_cliente] = [];
      }

      if (!this.proyectos_clientes[id_cliente].some((element) => element.id == id_proyecto)) {
        this.proyectos_clientes[id_cliente].push({ id: id_proyecto, nombre: nombre_proyecto });
      }
    },
    resaltarFila(fila) {
      return fila.texto.replace(fila.hora1Literal, /*html*/ `<span class="badge badge-warning">${fila.hora1Literal}</span>`).replace(fila.hora2Literal, /*html*/ `<span class="badge badge-warning">${fila.hora2Literal}</span>`);
    },
  },
  watch: {
    filas: {
      handler() {
        this.hayCambiosUnload = this.filas.length > 0;

        if (this.filas.length == 0) {
          if (this.$refs.popovers) {
            this.$refs.popovers.forEach((element) => {
              $(element).popover("dispose");
            });
          }
        }
      },
    },
    accessToken(value) {
      if (value) {
        localStorage.setItem("calendarToken", value);
      } else {
        localStorage.removeItem("calendarToken");
      }
    },
  },
};
</script>